import { Box }                       from '@chakra-ui/react';
import { Stack }                     from '@chakra-ui/react';
import { Text }                      from '@chakra-ui/react';
import { useTranslation }            from 'react-i18next';
import PageContainer                 from '@/components/pageContainer/PageContainer';
import ConfirmationResetPasswordForm from './forms/ConfirmationResetPasswordForm';
import { Button }                    from "@/components/ui/button";
import React                         from 'react';
import useTranslations               from '@/hooks/useTranslations';
import { useNavigate }               from 'react-router-dom';

const ConfirmationResetPassword = () => {

	const { t } = useTranslation();
	const [passwordHasBeenReseted, setPasswordHasBeenReseted] = React.useState(false);
	const { getNavigationTranslation } = useTranslations();
	const navigate = useNavigate();

	if (passwordHasBeenReseted) {
		return (
			<PageContainer type='public'>
				<Box
					display="flex"
					alignItems="center"
					height="100%"
					justifyContent="center"
				>
					<Box
						height="100%"
						maxWidth="600px"
						display="flex"
						flexDirection="column"
						justifyContent="space-between"
						padding="50px"
						marginBottom="70px"
					>
						<Box
							display="flex"
							alignItems="center"
							justifyContent="center"
							height="100%"
						>
							<Stack gap="30px" >
								<Box
									display="flex"
									flexDirection="column"
									gap="10px"
									maxWidth={{ base: 400, lg: 500 }}
								>
									<Text 
										className="poppins-semibold" 
										fontSize={{ base: 28, lg: 36 }}
									>
										{t('pages.confirmationResetPassword.onSuccess.title')}
									</Text>
									<Text fontSize="16px">{t('pages.confirmationResetPassword.onSuccess.message')}</Text>
								</Box>
								<Button 
									textWrap="wrap"
									height="unset"
									padding="12px 22px"
									onClick={
										() => navigate(getNavigationTranslation('login', 'path'))
									}>{t(`pages.login.form.actions.login`) }
								</Button>
							</Stack>
						</Box>
					</Box>
				</Box>
			</PageContainer>
		);
	}

	return (
		<PageContainer type='public'>
			<Box
				display="flex"
				alignItems="center"
				height="100%"
				justifyContent="center"
			>
				<Box
					height="100%"
					maxWidth="600px"
					display="flex"
					flexDirection="column"
					justifyContent="space-between"
					padding="50px"
				>
					<Box
                        display="flex"
						alignItems="center"
						justifyContent="center"
						height="100%"
                    >
						<Stack gap="30px" >
							<Box
								display="flex"
								flexDirection="column"
								gap="10px"
								maxWidth={{ base: 400, lg: 500 }}
							>
								<Text 
									className="poppins-semibold" 
									fontSize={{ base: 28, lg: 36 }}
								>
									{t('pages.confirmationResetPassword.label')}
								</Text>
							</Box>
							<ConfirmationResetPasswordForm setPasswordHasBeenReseted={setPasswordHasBeenReseted} />
						</Stack>
					</Box>
				</Box>
			</Box>
		</PageContainer>
	);
}

export default ConfirmationResetPassword;